'use client'
import { Dispatch, ReactNode, SetStateAction } from 'react';


import { initanchor, initwax, resetwax } from "../lib/actionsWax.js";
import { initPhantom, initsolana, resetsolana } from "../lib/actionsSol.ts";
import { Contract } from '../lib/definitions.ts';
import { ANCHOR, BC_SOLANA, BlockchainInfos, PHANTOM } from '../lib/blockchainSession.ts';

function setSelectedEndpoint(bcType:number, logType:number, selectedEndPt : string, AA:Contract, chainId:string | null = null){

  
   localStorage.setItem('endpoint', selectedEndPt );

   if(bcType == BC_SOLANA){
      resetsolana();
      initsolana(selectedEndPt);
      if(logType == PHANTOM){
        initPhantom();
      }
   }else{
      resetwax();
      initwax(selectedEndPt, AA.contract);
      if(logType == ANCHOR){
        initanchor(selectedEndPt, chainId);
      }
   }

}

type navbarinfosProp = {
  blockchaininfos:BlockchainInfos;
  setBCInfos: Dispatch<SetStateAction<BlockchainInfos>>
}

const NavBarInfos = (props: navbarinfosProp):ReactNode =>{
         
  const blockchaininfos=props.blockchaininfos;
  let accountName = blockchaininfos.myAccount;

  if(blockchaininfos.myAccount == null){
    accountName = 'not loggued';
  }
  else if (blockchaininfos.myAccount.length > 12){
    const a1 = blockchaininfos.myAccount.substr(0, 5);
    const a2 = blockchaininfos.myAccount.substr(blockchaininfos.myAccount.length - 5, 5);
    accountName = a1+'...'+a2;
  }
  
  const netName = blockchaininfos.testnet ? 'testnet' : blockchaininfos.localnet ? 'localnet' : 'mainnet';
  const endpointSt = localStorage.getItem('endpoint');

  let selectedEP = 0;

  if(endpointSt !== null){
    const selectedIdx = blockchaininfos.endpoints.indexOf(endpointSt);
    selectedEP = selectedIdx >= 0 ? selectedIdx : 0;
  }

  const listItems = blockchaininfos.endpoints.map((endPoint:string, index:number) => <option  key={'key-'+index} value={index}>{endPoint}</option>);

  return (<div>
            <div id="navbar-account">
              <button className='logout-btn' onClick= { async (e:any) => {
                const res2 = await fetch(props.blockchaininfos.baseAddr+'/api/setsession?network=wax-testnet&logtype=-1&account=&mode=1', { credentials:'include', redirect: 'manual'});
                const blockchaininfos = await res2.json();
                localStorage.removeItem('endpoint');
                props.setBCInfos(blockchaininfos);
              }}>X</button>
              <h5 id="account">{accountName}</h5></div>
            <span className="navbar-infos">{netName}</span>
            <select defaultValue={selectedEP} onChange= {(e:any) => { setSelectedEndpoint(blockchaininfos.bc_type,blockchaininfos.logType, blockchaininfos.endpoints[parseInt(e.target.value)], blockchaininfos.AA, blockchaininfos.chainId) } } id="endpoints-select">{listItems}</select>
          </div>
        );
}

export default NavBarInfos;